import { createFileRoute } from '@tanstack/react-router';
import PersonalDataIdentity from '@/features/account/profile/personal-data/identity';

export const Route = createFileRoute('/perfil/dados-pessoais/')({
  component: PersonalDataIdentity,
  staticData: { subtitle: 'Informações gerais' },
});
